export enum Indicator {
  TLI = 'TLI',
  TLIJ = 'TLIJ',
  RFI = 'RFI',
  PI = 'PI',
  TI = 'TI',
}

type ThresholdVariant = 'positive' | 'negative' | 'neutral';

export const DEFAULT_AREA: [ThresholdVariant, ThresholdVariant] = [
  'positive',
  'negative',
];

export interface Threshold {
  up: number;
  down: number;
  mid: number;
  variants: [ThresholdVariant, ThresholdVariant];
}

export const indicatorsThresholds: Record<Indicator, Threshold> = {
  [Indicator.TLI]: {
    up: 0.15,
    down: -0.15,
    variants: DEFAULT_AREA,
    mid: 0,
  },
  [Indicator.TLIJ]: {
    up: 0.2,
    down: -0.2,
    variants: DEFAULT_AREA,
    mid: 0,
  },
  [Indicator.RFI]: {
    up: 0.75,
    down: -0.75,
    variants: ['negative', 'positive'],
    mid: 0,
  },
  [Indicator.PI]: {
    up: 95,
    down: 5,
    variants: ['negative', 'positive'],
    mid: 50,
  },
  [Indicator.TI]: {
    up: 95,
    down: 5,
    variants: DEFAULT_AREA,
    mid: 50,
  },
};

type GetDirectionProps = {
  indicator: Indicator;
  up: number;
  down: number;
  value: number;
};

export const getDirection = ({
  indicator,
  up,
  down,
  value,
}: GetDirectionProps): ThresholdVariant => {
  const { variants } = indicatorsThresholds[indicator];
  const inversed = variants[1] === 'positive';

  let direction: ThresholdVariant = 'neutral';

  if (value > up) {
    direction = inversed ? 'negative' : 'positive';
  } else if (value < down) {
    direction = inversed ? 'positive' : 'negative';
  }

  return direction;
};
